import { useSelector } from 'react-redux'
import {
    selectUserAuthCheck,
    userSchoolsCountSelector,
} from '../../../../redux/userSlice'
import { useNavigate } from 'react-router-dom'
import { TabNames } from '../../../../routers/type'
import { useEffect } from 'react'

export const useSchoolCheck = () => {
    const authed = useSelector(selectUserAuthCheck)
    const schoolsCount = useSelector(userSchoolsCountSelector)
    const navigate = useNavigate()

    const loading = authed === undefined || schoolsCount === undefined
    const shouldRedirectToOnboarding = !authed || schoolsCount === 0

    useEffect(() => {
        if (loading || !shouldRedirectToOnboarding) return
        navigate(`/${TabNames.ON_BOARDING}`, { replace: true })
    }, [navigate, loading, shouldRedirectToOnboarding])
}
